const initialState = {
  deliveries: [],
  delivery: null,
  orderDeliveries: [],
  comments: [],
  commentsLoading: false,
  createCommentLoading: false,
  updateDeliveryLoading: false,
  deliveryLoading: false,
  loading: false,
  error: null,
  pageCount: 0,
  total: 0,
};

const deliveryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "DELIVERIES_LOADING":
    case "ORDER_DELIVERIES_LOADING":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "DELIVERIES_DELIVERIES":
      return {
        ...state,
        loading: false,
        deliveries: action.payload.data,
        pageCount: action.payload.meta?.pagination?.pageCount || 0,
        total: action.payload.meta?.pagination?.total || 0,
        error: null,
      };
    case "DELIVERIES_LOAD_MORE_SUCCESS":
      return {
        ...state,
        loading: false,
        deliveries: [...state.deliveries, ...action.payload.data],
        pageCount: action.payload.meta?.pagination?.pageCount || 0,
        total: action.payload.meta?.pagination?.total || 0,
        error: null,
      };
    case "DELIVERIES_ERROR": {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case "RESET_DELIVERIES": {
      return {
        ...state,
        deliveries: [],
        pageCount: 0,
        total: 0,
        loading: false,
        error: null,
      };
    }
    case "SET_DELIVERY":
      return {
        ...state,
        delivery: action.payload,
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_ERROR":
      return {
        ...state,
        error: action.payload,
      };
    case "ORDER_DELIVERIES_SUCCESS": {
      return {
        ...state,
        loading: false,
        orderDeliveries: [...(action.payload || [])],
        error: null,
      };
    }
    case "UPDATE_DELIVERY_LOADING": {
      return {
        ...state,
        updateDeliveryLoading: true,
      };
    }
    case "UPDATE_DELIVERY_SUCCESS": {
      return {
        ...state,
        updateDeliveryLoading: false,
        deliveries: state?.deliveries?.map((delivery) =>
          +delivery?.id === +action.payload?.id ? action.payload : delivery
        ),
      };
    }
    case "GET_DELIVERY_LOADING": {
      return { ...state, deliveryLoading: true };
    }
    case "GET_DELIVERY_SUCCESS": {
      return {
        ...state,
        deliveryLoading: false,
        error: null,
        delivery: action.payload,
      };
    }
    case "CLEAR_DELIVERY": {
      return { ...state, error: null, delivery: null, deliveryLoading: false };
    }

    case "CREATE_COMMENTS_DELIVERY_LOADING":
      return { ...state, createCommentLoading: true };
    case "CREATE_COMMENTS_DELIVERY_SUCCESS":
      return {
        ...state,
        createCommentLoading: false,
        comments: [action.payload, ...state.comments],
      };

    case "FETCH_COMMENTS_DELIVERY_LOADING":
      return { ...state, commentsLoading: true };

    case "FETCH_COMMENTS_DELIVERY_SUCCESS":
      return { ...state, comments: action.payload, commentsLoading: false };
    case "UPDATE_DELIVERY_COMMENT_SUCCESS": {
      const updatedComments = state.comments.map((comment) => {
        if (+comment?.id === +action.payload?.id) {
          return action.payload;
        }
        return comment;
      });
      return {
        ...state,
        comments: updatedComments,
        commentsLoading: false,
      };
    }
    case "DELETE_DELIVERY_COMMENT_SUCCESS": {
      const updatedComments = state.comments.filter((comment) => {
        return +comment?.id !== +action.payload;
      });
      return {
        ...state,
        comments: updatedComments,
        commentsLoading: false,
      };
    }
    default:
      return state;
  }
};

export default deliveryReducer;
